import type { DeliveryInfoItem } from '@eliadmin/core/src/components/dlz/product-detail/types';
import { CmsIcon } from '@eliadmin/core/src/components/dlz/ui/cms-image';

/** Figma „Delivery info“: grey card with the administration's benefits shown on the product. */
export function DeliveryBox({ items }: { items: DeliveryInfoItem[] }) {
  if (!items.length) return null;

  return (
    <ul className="flex flex-col gap-4 rounded-[18px] bg-[#F5F6F7] p-4 lg:p-6">
      {items.map(item => (
        <li key={item.id} className="flex items-center gap-4">
          <CmsIcon image={item.icon} className="size-8" />
          <div className="flex min-w-0 flex-col gap-1 lg:gap-2">
            <p className="dlz-body-m-medium text-[#0F1012]">{item.title}</p>
            {item.text ? <p className="dlz-body-s text-[#6B7079]">{item.text}</p> : null}
          </div>
        </li>
      ))}
    </ul>
  );
}
